import create from 'zustand';

export interface RobotState {
    mobileTab: 'task' | 'code' | 'robot';
    setMobileTab: (newTab: RobotState['mobileTab']) => void;
}
export const useRobotState = create<RobotState>((set) => ({
    mobileTab: 'task',
    setMobileTab: (newTab: RobotState['mobileTab']) => set({ mobileTab: newTab }),
}));
